import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import AuthPage from "@/pages/AuthPage";
import Studio from "@/pages/Studio";
import MyVideos from "@/pages/MyVideos";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#8B5CF6]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" state={{ from: location }} replace />;
  return children;
};

const NotFound = () => (
  <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground">
    Page introuvable — <a href="/" className="text-[#8B5CF6] hover:underline ml-1">retour à l'accueil</a>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/tarifs" element={<Pricing />} />
              <Route path="/connexion" element={<AuthPage />} />
              <Route path="/inscription" element={<AuthPage />} />
              <Route path="/studio" element={<Protected><Studio /></Protected>} />
              <Route path="/mes-videos" element={<Protected><MyVideos /></Protected>} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
